export const transformSimilarItemsFromV3 = (similarItems: any[]) =>
    similarItems.map<any>((algoliaItem: any) => transformSimilarItemFromV3(algoliaItem));

const transformSimilarItemFromV3 = (algoliaItem: any) => {
    const transformed: any = {
        biddingInfo: {
            bidActivityCount: algoliaItem.bidCount,
            isAvailable: true,
            isLocked: false,
            isPassed: false,
            isSold: false,
            leadingBid: algoliaItem.currentBid,
            salePrice: algoliaItem.salePrice,
        },
        buyNow: { price: algoliaItem.buyNowPrice, status: algoliaItem.buyNowStatus },
        catalog: {
            buyersPremium: {},
            catalogId: algoliaItem.catalog.id,
            catalogStatus: algoliaItem.catalog.status,
            currency: algoliaItem.currency,
            hasVideo: false,
            isCatalogOnly: algoliaItem.auctionType === 'catalogOnly',
            saleStartTs: algoliaItem.saleStartTs,
        },
        catalogRegistration: {},
        categories: algoliaItem.categories,
        item: {
            catalogId: algoliaItem.catalog.id,
            highBidEstimate: algoliaItem.highBidEstimate,
            imageVersion: algoliaItem.imageVersion,
            index: 9999,
            isSEOExcluded: algoliaItem.SEOExcluded,
            itemId: algoliaItem.itemId,
            lotNumber: algoliaItem.lotNumber,
            lowBidEstimate: algoliaItem.lowBidEstimate,
            photos: algoliaItem.photos,
            sellerId: algoliaItem.house.id,
            startPrice: algoliaItem.currentBid,
            title: algoliaItem.title,
        },
        itemDetail: {
            description: algoliaItem.shortDescription,
            itemId: algoliaItem.itemId,
        },
        itemId: algoliaItem.itemId,
        liveItemStatus: {},
        promoted: Boolean(algoliaItem.promoted),
        seller: { name: algoliaItem.house.name, sellerId: algoliaItem.house.id },
        version: '20191113', // version of this model
    };
    if (algoliaItem.catalog.title) {
        transformed.catalog.title = algoliaItem.catalog.title;
    }
    if (algoliaItem.status === 'sold') {
        transformed.biddingInfo.salePrice = algoliaItem.salePrice;
        transformed.biddingInfo.isAvailable = false;
        transformed.biddingInfo.isSold = true;
        transformed.biddingInfo.isLocked = false;
        transformed.biddingInfo.isPassed = false;
    }
    return transformed;
};
